import Component from 'gia/Component'
import eventbus from 'gia/eventbus';
import stage from '../components/stage'
import renderer from '../components/render'

import _each from 'lodash.foreach'
import gsap from 'gsap'
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
import { SplitText } from 'gsap/SplitText.js'
gsap.registerPlugin(ScrollTrigger, SplitText);



class Trust extends Component {

  constructor(element) {

    super(element)

    this.body = document.body
    this.element = element
    this.i = 0


    this.ref = {
     title: [],
     first: null,
      spacer: [],
      card: [],
      arrow: []
    }

  }

  mount() {


    // this.ref.title.forEach((item, i) => {

    //     const title = new SplitText(item, {
    //         type: "words",
    //         wordsClass: 'word'
    //     })

    //     title.words.forEach((item, i) => {
    //         item.style = `--word-index: ${i}`
    //     })


    //     //$(item).addClass('visible')

    //     ScrollTrigger.create({
    //         trigger: this.element,
    //         start: "top 50%",
    //         onToggle: () => {
    //             item.classList.toggle("visible")
    //         }
    //       //  once: true
    //     });


    // })

    //let mm = gsap.matchMedia();

    // mm.add("(min-width: 641px)", () => {

    //           this.ref.card.forEach((item, i) => {

    //               gsap.set(item, {
    //                   opacity: 0,
    //                   xPercent: -100
    //               })
    //               gsap.set(this.ref.arrow[i], {
    //                   opacity: 0,
    //                   xPercent: -100
    //               })

    //               const tl = gsap.timeline({
    //                   scrollTrigger: {
    //                       trigger: this.ref.spacer[i],
    //                       start: "top bottom",
    //                       end: "top top",
    //                       scrub: .2,

    //                       toggleActions: "play reverse play reverse"
    //                   }
    //               });

    //               tl.to(this.ref.arrow[i], {
    //                   opacity: 1,
    //                   duration: 0.05
    //               }, 0)
    //               tl.to(this.ref.arrow[i], {
    //                   xPercent: 0,
    //                   duration: 0.1
    //               }, 0)
    //               tl.to(item, {
    //                   opacity: 1,
    //                   xPercent: 0,
    //                   duration: 0.2
    //               }, 0)
    //               //tl.to(item, { opacity: 0, yPercent: -50, duration: 0.2 }, 0.8)


    //           })

    //           gsap.set(this.ref.first, {
    //               opacity: 0,
    //               xPercent: -100
    //           })


    //           const tl = gsap.timeline({
    //               scrollTrigger: {
    //                   trigger: this.element,
    //                   start: "top 50%",
    //                   end: "top top",
    //                   scrub: .2,
    //                   toggleActions: "play reverse play reverse"
    //               }
    //           });
    //           tl.to(this.ref.first, {
    //               opacity: 1,
    //               xPercent: 0,
    //               duration: 0.2
    //           }, 0)

        
    // });

    // mm.add("(max-width: 640px)", () => {
            this.ref.card.forEach((item, i) => {

               

                ScrollTrigger.create({
                    trigger: this.ref.spacer[i+1],
                    start: "top 75%",
                    onEnter: () => {
                        item.classList.add("visible")
                    },
                    onLeaveBack: () => {
                        item.classList.remove("visible")
                    }
                    //  once: true
                });



            })

            ScrollTrigger.create({
                trigger: this.ref.spacer[0],
                start: "top 75%",
                onEnter: () => {
                    this.ref.first.classList.add("visible")
                },
                onLeaveBack: () => {
                    this.ref.first.classList.remove("visible")
                }
                //  once: true
            });
  //  });

  
      

   
   

    }    



    resize(){

       


       

    }

    unmount() {



    }

}

module.exports = Trust



